import { filter, map, isNotNil } from 'ramda';
import { notEqual } from 'ramda-adjunct';
import { commitMutation,
  graphql } from 'react-relay';
import environment from '../../index';
import { basicMutationOnCompleted, onErrorMutation } from '../common/common';

const mutation = graphql`
  mutation DefineActiveTeamMutation($teamId: ID!, $userId: ID!) {
    defineActiveTeam(teamId: $teamId, userId: $userId) {
      ok
      error
      userTeam {
        id
        teamId
        apiKey
        name
        roles {
          role
          offerId
        }
        flexigets
        members {
          id
          user {
            id
            email
            roles
          }
          roles {
            role
            offerId
          }
          active
          dates {
            join
            lastConnection
          }
        }
      }
    }
  }
`;

export default ({ teamId, userId }, done) => {
  const variables = {
    teamId,
    userId
  };

  commitMutation(
    environment(),
    {
      mutation,
      variables,
      // The mutation returns the freshly activated `userTeam` (id, name,
      // apiKey, roles, members). Relay normalizes it by `id` and merges it
      // into the shared `userTeam` record synchronously on commit, so the UI
      // never flashes stale/empty roles. The only thing the payload cannot
      // express is flipping `active: false` on the members of the *former*
      // team (its members are not part of the new payload), which we do here.
      updater: (proxyStore, { defineActiveTeam: { ok, error } }) => {
        if (ok && !error) {
          const deactivateMembers = (team) => {
            if (isNotNil(team)) {
              const teamMembers = team.getLinkedRecords('members');
              if (isNotNil(teamMembers)) {
                const members = map(member => {
                  const user = member.getLinkedRecord('user');

                  if (isNotNil(user)) {
                    const id = user.getValue('id');
                    if (notEqual(id, userId)) return member;
                  }

                  member.setValue(false, 'active');
                  return member;
                })(filter(isNotNil, teamMembers));

                team.setLinkedRecords(members, 'members');
              }
            }
          };

          const root = proxyStore.get('userTeam');
          const formerTeamId = isNotNil(root) ? root.getValue('teamId') : null;

          if (isNotNil(formerTeamId) && notEqual(formerTeamId, teamId)) {
            deactivateMembers(proxyStore.get(formerTeamId));
          }
        }
      },
      onCompleted: ({ defineActiveTeam }) => basicMutationOnCompleted(defineActiveTeam, done),
      onError: error => onErrorMutation(error, done)
    }
  );
};
